import styled from 'styled-components';

export const ActionContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const CloseContainer = styled.button`
  border: 0;
  background: transparent;
  position: absolute;
  right: 10px;
  top: 10px;

  svg {
    width: 10px;
    height: 10px;
  }

  @media (min-width: ${props => props.theme.breakpoints.minWidth.M}) {
    align-items: center;
    display: flex;
    height: 10px;
    margin-left: 40px;
    padding: 0;
    position: relative;
    right: initial;
    top: initial;
  }
`;

export const Container = styled.div`
  background-color: ${props => props.theme.colors.textQuote(0.05)};
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 1200px;
  padding: 20px;
  position: relative;
  @media (min-width: ${props => props.theme.breakpoints.minWidth.M}) {
    align-items: center;
    flex-direction: row;
    padding: 20px 120px;
    form {
      margin-left: 28px;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 0;
  position: relative;
  width: 100%;
  .select {
    display: flex;
    flex-shrink: 0;
    margin-top: 0;
  }

  .select {
    margin-top: 10px;
  }
  .action {
    margin-top: 20px;
  }
  @media (min-width: ${props => props.theme.breakpoints.minWidth.M}) {
    align-items: center;
    flex-direction: row;
    flex-shrink: 0;
    padding: 20px;
    width: initial;
    .select {
      margin-left: 0;
      margin-top: 0;
    }
    .action {
      margin-left: 20px;
      margin-top: 0;
    }
  }
`;
